import React, { FC } from 'react';
import { CardContext } from 'types/Common';
import { StandardCover } from 'types/Cover';
import { CardGridItem, CardGridTile, InfoWrapper, MetaData, Title } from './Card.css';
import { CardVariant, cardSpec } from './cardVariants';
import { CardBody } from './parts/CardBody';
import { CardLink } from './parts/CardLink';

export type CardGridPropTypes = {
    variant: CardVariant;
    asset: StandardCover;
    showInfo?: boolean;
    withTileFocusOutline?: boolean;
    gridTestId?: string;
};

export const CardGrid: FC<CardGridPropTypes> = ({ variant, asset, showInfo, withTileFocusOutline, gridTestId, ...rest }) => {
    const spec = cardSpec(variant);
    const { title, metaData, defaultRenderSecondLine } = asset;
    const renderInfo = showInfo ?? spec.showInfo;
    const srLabel = renderInfo ? asset.channelName : [asset.channelName, title].filter(Boolean).join(', ');

    return (
        <CardGridItem
            data-test-id={gridTestId}
            gridWidths={spec.gridWidths}
            defaultRenderSecondLine={defaultRenderSecondLine}
            withTileFocusOutline={withTileFocusOutline}
        >
            <CardGridTile imageAspectRatio={spec.imageAspectRatio}>
                <CardLink cover={asset} {...rest}>
                    <CardBody variant={variant} asset={asset} srLabel={srLabel} />
                    {renderInfo && (
                        <InfoWrapper context={CardContext.COLLECTION}>
                            <Title context={CardContext.COLLECTION}>{title}</Title>
                            <MetaData context={CardContext.COLLECTION}>{metaData}</MetaData>
                        </InfoWrapper>
                    )}
                </CardLink>
            </CardGridTile>
        </CardGridItem>
    );
};
